const baseURL = '/api/schedule';
import basicRequest from '@/js/basicRequest.js';

const handleFn = (data: any, parameters: any, fn: any) => {
    if (fn != undefined && typeof fn == 'function') {
        fn(data, parameters);
    }
};
export const scheduleApi = {
    getScheduleRoutineSetting(opt?: any) {
        opt = opt || {};
        var url = baseURL + '/routine/setting';
        basicRequest.request({
            url,
            ajaxOpt: {
                //ajax的参数配置
                type: 'GET' //HTTP请求类型
            },
            urlParams: opt.urlParams,
            success: (data: any, parameters: any) => handleFn(data, parameters, opt.success),
            error: (data: any, parameters: any) => handleFn(data, parameters, opt.error)
        });
    },
    getScheduleList(opt?: any) {
        opt = opt || {};
        var url = baseURL + '/class';
        basicRequest.request({
            url,
            ajaxOpt: {
                //ajax的参数配置
                type: 'GET' //HTTP请求类型
            },
            urlParams: opt.urlParams,
            success: (data: any, parameters: any) => handleFn(data, parameters, opt.success),
            error: (data: any, parameters: any) => handleFn(data, parameters, opt.error)
        });
    },
    editScheduleRoutineSetting(opt?: any) {
        opt = opt || {};
        var url = baseURL + '/routine/setting';
        basicRequest.request({
            url,
            ajaxOpt: {
                //ajax的参数配置
                type: 'POST' //HTTP请求类型
            },
            data: opt.data,
            success: (data: any, parameters: any) => handleFn(data, parameters, opt.success),
            error: (data: any, parameters: any) => handleFn(data, parameters, opt.error)
        });
    },
    addSchedule(opt?: any) {
        opt = opt || {};
        var url = baseURL + '/class';
        basicRequest.request({
            url,
            ajaxOpt: {
                //ajax的参数配置
                type: 'POST' //HTTP请求类型
            },
            data: opt.data,
            success: (data: any, parameters: any) => handleFn(data, parameters, opt.success),
            error: (data: any, parameters: any) => handleFn(data, parameters, opt.error)
        });
    },
    editSchedule(opt?: any) {
        opt = opt || {};
        var url = baseURL + '/class/modify';
        basicRequest.request({
            url,
            ajaxOpt: {
                //ajax的参数配置
                type: 'POST' //HTTP请求类型
            },
            data: opt.data,
            success: (data: any, parameters: any) => handleFn(data, parameters, opt.success),
            error: (data: any, parameters: any) => handleFn(data, parameters, opt.error)
        });
    },
    deleteSchedule(opt?: any) {
        opt = opt || {};
        var url = baseURL + '/class/delete';
        basicRequest.request({
            url,
            ajaxOpt: {
                //ajax的参数配置
                type: 'POST' //HTTP请求类型
            },
            data: opt.data,
            success: (data: any, parameters: any) => handleFn(data, parameters, opt.success),
            error: (data: any, parameters: any) => handleFn(data, parameters, opt.error)
        });
    },
    exportScheduleTable(opt?: any) {
        opt = opt || {};
        var url = baseURL + '/class/export/table';
        basicRequest.request({
            url,
            ajaxOpt: {
                //ajax的参数配置
                type: 'GET', //HTTP请求类型
                responseType: 'blob'
            },
            urlParams: opt.urlParams,
            success: (data: any, parameters: any) => handleFn(data, parameters, opt.success),
            error: (data: any, parameters: any) => handleFn(data, parameters, opt.error)
        });
    },
    exportScheduleList(opt?: any) {
        opt = opt || {};
        var url = baseURL + '/class/export/list';
        basicRequest.request({
            url,
            ajaxOpt: {
                //ajax的参数配置
                type: 'GET', //HTTP请求类型
                responseType: 'blob'
            },
            urlParams: opt.urlParams,
            success: (data: any, parameters: any) => handleFn(data, parameters, opt.success),
            error: (data: any, parameters: any) => handleFn(data, parameters, opt.error)
        });
    }
};
